import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import PageWrapper from '../../components/pageWrapper/PageWrapper';
import { useFetching } from '../../common/hooks/useFetching';
import ConsentDialog from '../../components/consentDialog/ConsentDialog';
import { Team } from '../../models/Team';
import TeamManagement from '../../components/teamManagement/TeamManagement';
import { fetchTeams } from '../../api/TeamApi';
import StatusMessage, { notify } from '../../components/teamManagement/components/statusMessage/StatusMessage';
import { StatusMessageType } from '../../components/teamManagement/types/StatusMessageType';

const HomePage: React.FC = () => {
  const [pageRefresher, setPageRefresher] = useState<boolean>(false);
  const [showConsentDialog, setShowConsentDialog] = useState<boolean>(false);
  const [statusMessage, setStatusMessage] = useState<StatusMessageType | null>(null);
  const [team, setTeam] = useState<Team | null>(null);
  const [initialized, setInitialized] = useState<boolean>(false);
  const { isLoading, data: teams, error } = useFetching(fetchTeams, [pageRefresher]);

  if (error) {
    throw error;
  }

  useEffect(() => {
    if (!isLoading && !error) {
      if (teams?.length) {
        setTeam(teams[0]);
        setShowConsentDialog(false);
      } else setShowConsentDialog(true);
    }
  }, [error, isLoading]);

  const handleSubmit = async (status?: StatusMessageType) => {
    setInitialized(true);
    setPageRefresher((prevStat) => !prevStat);
    if (!status) return;
    if (status.details) {
      setStatusMessage(status);
    } else {
      notify(status);
    }
  };

  const resetStatusMessage = () => setStatusMessage(null);

  return (
    <PageWrapper title='Team Management'>
      <ToastContainer autoClose={10_000} position='top-right' draggable={false} closeButton={false} hideProgressBar={true} />
      {statusMessage && <StatusMessage status={statusMessage} onClose={resetStatusMessage} />}
      {!isLoading && showConsentDialog && <ConsentDialog initialized={initialized} onSubmitted={handleSubmit} />}
      {!isLoading && team && <TeamManagement team={team} onReviewCompleted={handleSubmit} />}
    </PageWrapper>
  );
};
export default HomePage;
